import Icon from "../Icon";
import Image from "../Image";
import { NavLink } from "react-router-dom";
import Ratio from "../Ratio";
import React from "react";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import useEvent from "../../hooks/useEvent";
import useFakeView from "../../hooks/useFakeView";
import { sortBy } from "lodash";

export interface ViewersWidgetProps {
  viewers?: {
    ID: string;
    image?: string;
  }[];
}

const ViewersWidget = ({ viewers }: ViewersWidgetProps) => {
  const event = useEvent();

  // Get fake view
  const fakeView = useFakeView();

  return (
    <div className="w-full">
      <div className="text-xs text-gray-400">Current Viewers</div>
      <div className="my-2 text-lg font-medium text-cream">
        {viewers &&
          `${viewers.length + fakeView} active ${
            viewers.length > 1 ? "viewers" : "viewer"
          }`}
      </div>
      <div className="flex flex-wrap my-4">
        {viewers && viewers.length ? (
          sortBy(viewers, ["image"]).map((viewer, key) => (
            <div className="w-1/5 pb-2 pr-2" key={key}>
              <NavLink to={`/${event}/profiles/${viewer.ID}`}>
                <div className="bg-gray-100">
                  <Ratio>
                    {viewer.image ? (
                      <Image src={viewer.image} />
                    ) : (
                      <div className="flex items-center justify-center w-full h-full text-xs text-gray-400 bg-gray-100">
                        <Icon icon={faUser} />
                      </div>
                    )}
                  </Ratio>
                </div>
              </NavLink>
            </div>
          ))
        ) : (
          <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
            No active viewers.
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewersWidget;
